// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Money24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Money24Circle: FC<Money24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-.975-9.15V25h2v-2.1c1.033-.15 1.9-.533 2.6-1.15.7-.617 1.05-1.517 1.05-2.7 0-.95-.296-1.788-.887-2.512-.592-.726-1.463-1.255-2.613-1.588-1.233-.35-2.1-.683-2.6-1-.5-.317-.75-.75-.75-1.3 0-.483.192-.888.575-1.213.383-.324.942-.487 1.675-.487.633 0 1.133.133 1.5.4s.65.667.85 1.2l1.85-.8a4.187 4.187 0 0 0-1.188-1.738c-.541-.475-1.229-.779-2.062-.912V7h-2v2.1c-.733.083-1.45.425-2.15 1.025-.7.6-1.05 1.442-1.05 2.525 0 .9.267 1.662.8 2.287.533.626 1.517 1.163 2.95 1.613 1.333.433 2.183.82 2.55 1.162.367.342.55.805.55 1.388 0 .65-.238 1.13-.713 1.438-.474.308-1.054.462-1.737.462-.8 0-1.446-.208-1.938-.625-.491-.417-.862-1.025-1.112-1.825l-1.85.75c.3 1.033.77 1.833 1.413 2.4a5.09 5.09 0 0 0 2.287 1.15Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Money24Circle;
